import React from 'react';
import {
  accountSubTypeLabelObject,
  sourceIconAccountsObject,
  sourceIconMeloAccountsObject,
  sourceIconMoviiAccountsObject
} from '../../../../store/catalogs/banks';
import FieldBold from '../../../Fields/FieldBold/FieldBold';

import classes from './AccountDestiny.module.scss';
import { documentTypesAbbreviationsObject, documentTypesLabelsObject } from '../../../../store/catalogs/documentTypes';
import utils from '../../../../services/utils';

const AccountDestiny = ({ collaborator, methodForPay }) => {
  let bankAccountOwnerIdentificationNumber, name, bankAccountType, bankAccountNumber, bankId, bankAccountOwnerIdentificationType;

  if (methodForPay === 'PSEPay') {
    ({
      collaboratorMoviiBankId: bankId,
      bankAccountNumber,
      bankAccountType,
      bankAccountOwnerIdentificationType,
      name,
      bankAccountOwnerIdentificationNumber
    } = collaborator);
  } else {
    ({
      bankId,
      bankAccountOwnerIdentificationType,
      bankAccountType,
      name,
      bankAccountNumber,
      bankAccountOwnerIdentificationType,
      bankAccountOwnerIdentificationNumber
    } = collaborator);

    /*   ({
      ,
      subtypeLabel,
      bankLast4Digits: bankNumber,
      endUser: { identificationTypeLabel, identificationNumber, name }
    } = druoAccounts[0]); */
  }

  return (
    <div className={classes.content}>
      <span className='semibold-18'>Cuenta destino</span>
      <FieldBold className={classes.bank} title='BANCO'>
        {methodForPay === 'PSEPay'
          ? sourceIconMoviiAccountsObject[bankId]
          : methodForPay === 'druoPay'
          ? sourceIconAccountsObject[bankId]
          : sourceIconMeloAccountsObject[bankId]}
      </FieldBold>
      <div className={classes.fields}>
        <FieldBold title='TIPO DE CUENTA' value={accountSubTypeLabelObject[bankAccountType]} />
        <FieldBold
          title='NÚMERO DE CUENTA'
          value={`${methodForPay !== 'PSEPay' ? '****' : ''}${utils.getLast4Digit(bankAccountNumber)}`}
        />
        <FieldBold className={classes.one} title='TITULAR DE CUENTA' value={name} />
        <FieldBold
          title='IDENTIFICACIÓN DEL TITULAR'
          value={`${
            methodForPay === 'PSEPay'
              ? documentTypesLabelsObject[bankAccountOwnerIdentificationType]
              : documentTypesAbbreviationsObject[bankAccountOwnerIdentificationType]
          } ${bankAccountOwnerIdentificationNumber}`}
        />
      </div>
    </div>
  );
};

export default AccountDestiny;
